<template>
    <!-- https://www.svgrepo.com/svg/478185/wireless-keyboard-1 -->
    <svg
        height="20px"
        width="20px"
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xml:space="preserve"
    >
        <g>
            <path
                class="st0"
                d="M468.184,235.981H43.817c-16.192,0-29.332,13.141-29.332,29.332v201.043c0,25.216,20.428,45.643,45.643,45.643
		h391.754c25.216,0,45.634-20.428,45.634-45.643V265.314C497.515,249.122,484.375,235.981,468.184,235.981z M325.014,281.983h46.002
		v46.002h-46.002V281.983z M325.014,350.985h46.002v46.01h-46.002V350.985z M255.997,281.983h46.007v46.002h-46.007V281.983z
		 M255.997,350.985h46.007v46.01h-46.007V350.985z M186.995,281.983h46.002v46.002h-46.002V281.983z M186.995,350.985h46.002v46.01
		h-46.002V350.985z M117.993,281.983h46.002v46.002h-46.002V281.983z M117.993,350.985h46.002v46.01h-46.002V350.985z
		 M94.992,465.999H48.991v-46.002h46.002V465.999z M94.992,396.996H48.991v-46.01h46.002V396.996z M94.992,327.985H48.991v-46.002
		h46.002V327.985z M394.007,465.999H117.993v-46.002h276.014V465.999z M463.019,465.999h-46.001v-46.002h46.001V465.999z
		 M463.019,396.996h-69.012V281.983h69.012V396.996z"
            />
            <path
                class="st0"
                d="M153.616,64.794c29.175-20.097,64.371-31.85,102.386-31.859c38.017,0.01,73.202,11.762,102.388,31.859
		c7.489,5.156,17.744,3.262,22.909-4.218c5.155-7.499,3.271-17.744-4.218-22.909C342.657,13.949,300.874-0.009,256.002,0
		c-44.871-0.009-86.664,13.949-121.078,37.667c-7.489,5.165-9.373,15.42-4.217,22.909C135.871,68.065,146.126,69.949,153.616,64.794
		z"
            />
            <path
                class="st0"
                d="M335.747,122.75c4.421-6.423,2.803-15.218-3.612-19.637h-0.008c-21.623-14.915-47.922-23.7-76.125-23.69
		c-28.201-0.009-54.502,8.776-76.133,23.69c-6.423,4.42-8.041,13.214-3.621,19.628c4.421,6.424,13.214,8.041,19.629,3.621
		c17.156-11.808,37.786-18.7,60.125-18.71c22.339,0.01,42.961,6.901,60.107,18.71C322.533,130.782,331.318,129.165,335.747,122.75z"
            />
            <path
                class="st0"
                d="M224.805,168.531c-5.357,3.686-6.708,11.01-3.033,16.357c3.685,5.358,11.008,6.708,16.357,3.033
		c5.109-3.511,11.201-5.55,17.873-5.55c6.662,0,12.764,2.049,17.855,5.541c5.348,3.685,12.672,2.334,16.357-3.014
		c3.685-5.349,2.334-12.672-3.014-16.357c-8.84-6.102-19.647-9.694-31.198-9.694C244.442,158.837,233.645,162.449,224.805,168.531z"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "WirelessKeyboardIcon",
};
</script>

<style scoped></style>
